module.exports = __webpack_public_path__ + "static/img/internet.c5b79ff8.png";